/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1CourseregistrationEnrollmentGridChildrenQueryResponse,
  GetApiV1CourseregistrationEnrollmentGridChildrenQueryParams,
  GetApiV1CourseregistrationEnrollmentGridChildren401,
  GetApiV1CourseregistrationEnrollmentGridChildren500,
} from "../../types/courseRegistrationEnrollmentController/GetApiV1CourseregistrationEnrollmentGridChildren.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1CourseregistrationEnrollmentGridChildren } from "../../clients/courseRegistrationEnrollmentController/getApiV1CourseregistrationEnrollmentGridChildren.ts";

export const getApiV1CourseregistrationEnrollmentGridChildrenQueryKey = (
  params?: GetApiV1CourseregistrationEnrollmentGridChildrenQueryParams,
) =>
  [
    { url: "/api/v1/courseregistration/enrollment/grid/children" },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1CourseregistrationEnrollmentGridChildrenQueryKey =
  ReturnType<typeof getApiV1CourseregistrationEnrollmentGridChildrenQueryKey>;

export function getApiV1CourseregistrationEnrollmentGridChildrenQueryOptions(
  params?: GetApiV1CourseregistrationEnrollmentGridChildrenQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey =
    getApiV1CourseregistrationEnrollmentGridChildrenQueryKey(params);
  return queryOptions<
    GetApiV1CourseregistrationEnrollmentGridChildrenQueryResponse,
    ResponseErrorConfig<
      | GetApiV1CourseregistrationEnrollmentGridChildren401
      | GetApiV1CourseregistrationEnrollmentGridChildren500
    >,
    GetApiV1CourseregistrationEnrollmentGridChildrenQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1CourseregistrationEnrollmentGridChildren(params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Carrega sob demanda os alunos de um grupo específico (turma + polo) do grid de matrículas, com suporte a paginação. Deve ser chamado ao expandir uma linha do grid passando o filtro (childrenFilter) do elemento pai. Use poloId = 0 ou omita para grupos sem polo (MBX Online). **(Requer Authorization para autenticação)**
 * @summary Retorna os alunos (children) paginados de um grupo do grid de matrículas (Requer Authorization para autenticação)
 * {@link /api/v1/courseregistration/enrollment/grid/children}
 */
export function useGetApiV1CourseregistrationEnrollmentGridChildren<
  TData = GetApiV1CourseregistrationEnrollmentGridChildrenQueryResponse,
  TQueryData = GetApiV1CourseregistrationEnrollmentGridChildrenQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1CourseregistrationEnrollmentGridChildrenQueryKey,
>(
  params?: GetApiV1CourseregistrationEnrollmentGridChildrenQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1CourseregistrationEnrollmentGridChildrenQueryResponse,
        ResponseErrorConfig<
          | GetApiV1CourseregistrationEnrollmentGridChildren401
          | GetApiV1CourseregistrationEnrollmentGridChildren500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1CourseregistrationEnrollmentGridChildrenQueryKey(params);

  const query = useQuery(
    {
      ...getApiV1CourseregistrationEnrollmentGridChildrenQueryOptions(
        params,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1CourseregistrationEnrollmentGridChildren401
      | GetApiV1CourseregistrationEnrollmentGridChildren500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
